const cents = (money) => money?.cents || 0

// Pushed fees other than the courier fee. Older API payloads have no
// customer_fee_excluding_delivery, so fall back to the raw fee.
export const customerFeeCents = (a) =>
  a?.customer_fee_excluding_delivery ? cents(a.customer_fee_excluding_delivery) : cents(a?.fee_to_charge_customer)

export function fulfillmentFeeLabel(fulfillmentMethodType) {
  if (fulfillmentMethodType === 'PickupFulfillmentMethod') return 'Fulfillment Fee'
  if (fulfillmentMethodType === 'ShippingFulfillmentMethod') return 'Shipping Fee'
  return 'Delivery Fee'
}

export function totalsLinesFromCheckout(checkoutAttributes, { fulfillmentMethodType } = {}) {
  if (!checkoutAttributes) return null
  const a = checkoutAttributes

  const hasFulfillmentAmountOff = cents(a.fulfillment_amount_off) > 0
  const hasBeenPaid = a.payment_status === 'paid'
  const hasAccountCreditAmount = cents(a.account_credit_amount) > 0
  const hasPassCreditAmount = cents(a.pass_credit_amount) > 0
  const hasAmountRemainingToCharge = (hasAccountCreditAmount || hasPassCreditAmount) && !hasBeenPaid

  const discount =
    cents(a.discount_code_amount) > 0
      ? {
          label: a.discount_codes ? `Discount (${a.discount_codes})` : 'Discount Codes',
          amountFormatted: a.discount_code_amount.format
        }
      : null

  const fulfillmentDiscount =
    cents(a.order_fulfillment_discount_amount) > 0
      ? { label: 'Fulfillment Discount', amountFormatted: a.order_fulfillment_discount_amount.format }
      : null

  // A courier fee (Uber Direct) is folded into the delivery line the customer
  // already knows; it never appears as its own line.
  const hasCourierFee = cents(a.uber_direct_fee) > 0
  const deliveryFormatted = hasCourierFee
    ? a.customer_delivery_fee?.format || null
    : cents(a.fulfillment_amount) > 0
      ? hasFulfillmentAmountOff
        ? a.net_fulfillment_amount.format
        : a.fulfillment_amount.format
      : null

  const breakdown = (a.taxes_and_fees_breakdown || []).map((fee) => ({
    description: fee.description,
    amountFormatted: fee.amount?.format
  }))
  let taxes = null
  if (customerFeeCents(a) > 0) {
    taxes = { label: 'Taxes & Fees', totalFormatted: a.taxes_and_fees?.format, breakdown }
  } else if (cents(a.tax_amount) > 0) {
    taxes = { label: 'Taxes', totalFormatted: a.tax_amount?.format, breakdown }
  }

  const credits = []
  if (!hasBeenPaid) {
    if (cents(a.pass_signup_credit_amount) > 0) {
      credits.push({ label: 'Amount covered by sign up bonus', amountFormatted: a.pass_signup_credit_amount.format })
    }
    if (hasPassCreditAmount) {
      credits.push({ label: 'Amount covered by pass credit', amountFormatted: a.pass_credit_amount.format })
    }
    if (hasAccountCreditAmount) {
      credits.push({ label: 'Amount covered by account credit', amountFormatted: a.account_credit_amount.format })
    }
  }

  return {
    subtotalFormatted: a.cart_total_amount?.format || '',
    discount,
    fulfillmentDiscount,
    deliveryFormatted,
    deliveryOriginalFormatted: hasFulfillmentAmountOff && !hasCourierFee ? a.fulfillment_amount?.format || null : null,
    deliveryLabel: fulfillmentFeeLabel(fulfillmentMethodType),
    taxes,
    tip: cents(a.tip_amount) > 0 ? { label: 'Tip', amountFormatted: a.tip_amount.format } : null,
    credits,
    todaysTotalFormatted: (hasAmountRemainingToCharge ? a.chargeable_amount?.format : a.bottle_total?.format) || ''
  }
}
